import { ModalityType } from '@asktia/tia-fhir-questionnaire/dist/src/validators/QuestionnaireResponse'
import { Button, Flex, Heading, Paragraph, TiaModal } from '@asktia/tia-ui'
import { CloseIcon } from 'src/components/Blocks/Icons'

interface QuestionnaireValidationModalProps {
    hideModal: () => void
    modality: ModalityType
    errorMessage?: string
}

export const QuestionnaireValidationModal = ({
    hideModal,
    modality,
    errorMessage
}: QuestionnaireValidationModalProps) => {
    const getModalContent = () => {
        switch (modality) {
            case 'DQ':
                return {
                    title: 'No longer a good fit',
                    message:
                        'Based on your current health situation, this medication is no longer a good fit for you. Your care team will be reaching out to follow up with you promptly with next steps.'
                }
            case 'ITER_HOLD':
                return {
                    title: "You're not yet ready for a refill",
                    message:
                        'Please re-submit this intake form after having taken 3 or more weeks of your current medication'
                }
            case 'SYNC':
                return {
                    title: 'Please schedule an appointment',
                    message:
                        'Your care team would like to discuss your current health situation in more detail to assess next steps. Please proceed to the next page to schedule an appointment with an Open Loop provider to not cause any delays in your care'
                }
            case 'ASYNC':
                return {
                    title: 'Review in Progress',
                    message:
                        'Thank you for sharing about your current health situation! Your responses will be reviewed by the Open Loop care team and they will be getting in touch shortly with details about your refill.'
                }
            default:
                return {
                    title: 'Error',
                    message:
                        errorMessage ||
                        'An unexpected error occurred. Please try again or contact support.'
                }
        }
    }

    const content = getModalContent()

    return (
        <TiaModal>
            <Flex
                sx={{
                    justifyContent: 'space-between',
                    mb: 5
                }}
            >
                <Heading h2 sx={{ m: 0 }}>
                    {content.title}
                </Heading>
                <Button variant="unstyled" onClick={hideModal}>
                    <CloseIcon color="supportText" />
                </Button>
            </Flex>
            <Paragraph sx={{ mb: 5 }}>{content.message}</Paragraph>
            <Button onClick={hideModal} fullWidth>
                {modality === 'SYNC' ? 'Book Now' : 'Close'}
            </Button>
        </TiaModal>
    )
}
